import React, { useState } from "react";
import Header from "../../components/header";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Grid, Button, Typography } from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import "./style.css";
import Carousel from "../../components/carousel";
import CompareInput from "../../components/compareInput";
import VideLink from "./components/videoLink";
import Trending from "./components/trending";
import TopList from "./components/topList";
import TopComparison from "./components/comparison";
import Footer from "../../components/footer";
const useStyles = makeStyles((theme) => ({
  alignItemsAndJustifyContent: {
    height: "80%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  heading: {
    fontWeight: "bold",
    color: "#fff",
    marginBottom: "30px",
    textAlign: "center",
  },
  subtitle: {
    color: "#FFF",
    fontSize: "22px",
    marginBottom: "40px",
    letterSpacing: "1px",
    textAlign: "center",
  },
  compareContainer: {
    position: "relative",
    width: "90%",
    maxWidth: "600px",
    margin: "0 auto 2em",
    zIndex: 2,
  },
  compareContainer1: {
    width: "100%",
    maxWidth: 900,
    margin: "3em auto 0",
  },
  inputBox: {
    width: "100%",
    // maxWidth: "520px",
  },

  input: {
    width: "100%",
    // maxWidth: "500px",
    height: "30px",
    margin: "5px 20px",
    padding: "0px 10px",
    fontSize: "16px",
  },
  icon: {
    position: "absolute",
    right: "5px",
  },
}));
export default function Home() {
  const [inputList, setInputList] = useState([{ text: "" }]);

  // handle input change
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    var list = [...inputList];
    list[index][name] = value;
    setInputList(list);

    switch (index) {
      case 0:
        if (list[index][name].length > 0 && inputList.length === 1) {
          setInputList([...inputList, { text: "" }]);
        } else if (list[index][name].length === 0 && inputList.length > 1) {
          inputList.splice(index, 1);
          setInputList([...inputList]);
        }
        break;
      case 1:
        if (list[index][name].length > 0 && inputList.length === 2) {
          setInputList([...inputList, { text: "" }]);
        } else if (list[index][name].length === 0 && inputList.length > 2) {
          inputList.splice(index, 1);
          setInputList([...inputList]);
        }
        break;
      case 2:
        if (list[index][name].length > 0 && inputList.length === 3) {
          setInputList([...inputList, { text: "" }]);
        } else if (list[index][name].length === 0 && inputList.length > 3) {
          inputList.splice(index, 1);
          setInputList([...inputList]);
        }
        break;
      case 3:
        if (list[index][name].length > 0 && inputList.length === 4) {
          setInputList([...inputList, { text: "" }]);
        } else if (list[index][name].length === 0 && inputList.length > 4) {
          inputList.splice(index, 1);
          setInputList([...inputList]);
        }
        break;
      case 4:
        if (list[index][name].length > 0 && inputList.length === 5) {
          setInputList([...inputList, { text: "" }]);
        } else if (list[index][name].length === 0 && inputList.length > 5) {
          inputList.splice(index, 1);
          setInputList([...inputList]);
        }
        break;
      case 5:
        if (list[index][name].length > 0 && inputList.length === 6) {
          setInputList([...inputList, { text: "" }]);
        } else if (list[index][name].length === 0 && inputList.length > 6) {
          inputList.splice(index, 1);
          setInputList([...inputList]);
        }
        break;
      default:
        break;
    }
  };

  const handleRemove = (index) => {
    inputList.splice(index, 1);
    setInputList([...inputList]);
  };
  const classes = useStyles();
  return (
    <div>
      <div id="banner">
        <div id="overlay">
          <Header />
          <div className="alignItemsAndJustifyContent">
            <Typography variant="h2" className={classes.heading}>
              Compare everything
            </Typography>
            <Typography variant="subtitle1" className={classes.subtitle}>
              Smartphones, Cities, Graphics Cards, Universities, and much more
            </Typography>
            <div className={classes.compareContainer}>
              {inputList.map((x, i) => {
                return (
                  <CompareInput
                    key={i}
                    value={x.text}
                    handleChange={handleInputChange}
                    handleRemove={handleRemove}
                    listLength={inputList.length}
                    index={i}
                  />
                );
              })}
              {/* {inputList.map((x, i) => {
                return (
                  <div className="box">
                    <div className={classes.inputBox}>
                      <input
                        name="text"
                        className={classes.input}
                        placeholder="Type here to compare upto 7 items"
                        value={x.text}
                        onChange={(e) => handleInputChange(e, i)}
                      />
                      <DeleteOutlineIcon className={classes.icon} />
                    </div>
                    <div className="btn-box">
                      {inputList.length !== 1 && (
                        <button
                          className="mr10"
                          onClick={() => handleRemoveClick(i)}
                        >
                          Remove
                        </button>
                      )}
                      {inputList.length - 1 === i && (
                        <Button
                          color="secondary"
                          variant="contained"
                          size="small"
                          onClick={handleAddClick}
                        >
                          Compare
                        </Button>
                      )}
                    </div>
                  </div>
                );
              })} */}
            </div>
          </div>
        </div>
      </div>
      <Container>
        <Carousel />
        <VideLink />
      </Container>
      <div className="colorPart">
        <Container>
          <Trending title="SmartPhones" />
          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <TopList heading="popular" />
            </Grid>
            <Grid item xs={12} md={4}>
              <TopList heading="top rated" />
            </Grid>
            <Grid item xs={12} md={4}>
              <TopList heading="newest" />
            </Grid>
          </Grid>
          <TopComparison />
        </Container>
      </div>
      <Container>
        <Trending title="HeadPhones" />
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <TopList heading="popular" />
          </Grid>
          <Grid item xs={12} md={4}>
            <TopList heading="top rated" />
          </Grid>
          <Grid item xs={12} md={4}>
            <TopList heading="newest" />
          </Grid>
        </Grid>
        <TopComparison />
      </Container>
      <div className="colorPart">
        <Container>
          <Trending title="SmartWatches" />
          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <TopList heading="popular" />
            </Grid>
            <Grid item xs={12} md={4}>
              <TopList heading="top rated" />
            </Grid>
            <Grid item xs={12} md={4}>
              <TopList heading="newest" />
            </Grid>
          </Grid>
          <TopComparison />
        </Container>
      </div>
      <Container>
        <Trending title="Cameras" />
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <TopList heading="popular" />
          </Grid>
          <Grid item xs={12} md={4}>
            <TopList heading="top rated" />
          </Grid>
          <Grid item xs={12} md={4}>
            <TopList heading="newest" />
          </Grid>
        </Grid>
        <TopComparison />
      </Container>
      <div className="colorPart">
        <Container>
          <Trending title="Portable Speakers" />
          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <TopList heading="popular" />
            </Grid>
            <Grid item xs={12} md={4}>
              <TopList heading="top rated" />
            </Grid>
            <Grid item xs={12} md={4}>
              <TopList heading="newest" />
            </Grid>
          </Grid>
          <TopComparison />
        </Container>
      </div>
      <Footer />
    </div>
  );
}
